<template>
<div class="login-container">
    <div class="login-box">
        <div class="login-title">研岸刷题后台管理系统</div>
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0" class="login-form">
            <el-form-item prop="username">
                <el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
            </el-form-item>

            <el-form-item prop="password">
                <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" style="width: 100%;" @click="handleLogin" :loading="loading">登录</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            loading: false,
            loginForm: {
                username: 'admin',
                password: ''
            },
            loginRules: {
                username: [{
                    required: true,
                    message: '请输入用户名',
                    trigger: 'blur'
                }],
                password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    methods: {
        handleLogin() {
            this.$refs.loginForm.validate(async valid => {
                if (valid) {
                    this.loading = true
                    const { data: res } = await this.$http.post('login', this.loginForm);
                    if (res.code !== 200) {
                        this.$message.error("账号或密码错误");
                    } else {
                        this.$message.success('登陆成功！');
                        window.localStorage.setItem('mzxltoken', res.token);
                        this.$router.push("/");
                    }
                    this.loading = false
                } else {
                    this.$message.error("请检查输入");
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f0f2f5;
}

.login-box {
    width: 400px;
    padding: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-title {
    text-align: center;
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
}

.login-form ::v-deep .el-input__inner {
    height: 40px;
}
</style>
